import { SaleConfigCalendarToShowField } from "@/utils/sale-config-calendar-to-show-field";

export class CrmSettings {
	HistoryFilterEventTypeIDs = [1, 2, 3, 4, 5, 6, 7, 8] as number[];
	CalendarToShowFields:SaleConfigCalendarToShowField[] = [];
	CalendarToShowHoverFields:SaleConfigCalendarToShowField[] = [];

	constructor(data: any) {
		if (data?.HistoryFilterEventTypeIDs) {
			this.HistoryFilterEventTypeIDs = data.HistoryFilterEventTypeIDs;
		}
		this.CalendarToShowFields = (data?.CalendarToShowFields || []).map((d:any)=> new SaleConfigCalendarToShowField(d));
		this.CalendarToShowHoverFields = (data?.CalendarToShowHoverFields || []).map((d:any)=> new SaleConfigCalendarToShowField(d));
	}

	getJSON() {
		return {
			HistoryFilterEventTypeIDs: this.HistoryFilterEventTypeIDs,
			CalendarToShowFields: this.CalendarToShowFields.map(c=>c.getJSON()),
			CalendarToShowHoverFields: this.CalendarToShowHoverFields.map(c=>c.getJSON()),
		};
	}
}
